import React from "react";

import { RIGHT_OF_WITHDRAWAL_MODEL } from "../../models/model";
import { Modal } from "@/components/molecules/NewModal";
import { RideGlInformationOutline } from "@rimac-seguros/ride-system-components";

import "./styles.scss";

export const ModalRightOfWithdrawal = ({ isOpen, onClose }) => {
  const { title, items, tooltip } = RIGHT_OF_WITHDRAWAL_MODEL;

  return (
    <Modal
      isOpen={isOpen}
      fullContentOnlyMobile
      onClose={onClose}
      className="col-span-full lg:col-span-8 lg:col-start-3"
      classNameGrid="max-h-dvh overflow-y-auto custom-scroll lg:max-h-auto lg:overflow-y-hidden"
    >
      <div className="modal-rofwd">
        <div className="flex flex-col custom-scroll gap-ride-gl-spacing-2xlarge">
          <div className="modal-rofwd_title">
            <h3>{title}</h3>
          </div>
          <ul>
            {items.map((item, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
          <div className="modal-rofwd_tooltip">
            <RideGlInformationOutline size="large" />
            <p dangerouslySetInnerHTML={{ __html: tooltip }} />
          </div>
        </div>
      </div>
    </Modal>
  );
};
